import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[finderAriaLabelHtml]',
    standalone: true
})
export class AriaLabelHtmlDirective implements AfterViewInit {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) { }

    ngAfterViewInit(): void {
        this.setAriaLabel();
    }

    private setAriaLabel() {
        const innerText = this.el.nativeElement.innerText;
        this.renderer.setAttribute(this.el.nativeElement, 'aria-label', innerText);
    }
}
